import React from 'react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import CopyIcon from '@atlaskit/icon/glyph/copy';
import { Stack, Text } from '@atlaskit/primitives';
import TextArea from '@atlaskit/textarea';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type EmbedCodeProps = {
	embedCode: string;
};

const onCopy = (embedCode: string) => {
	navigator.clipboard.writeText(embedCode);
};

export const EmbedCode = ({ embedCode }: EmbedCodeProps) => {
	const { formatMessage } = useIntl();

	return (
		<Stack space="space.100">
			<Heading size="xsmall" as="h2">
				{formatMessage(messages.label)}
			</Heading>
			<Text as="p">{formatMessage(messages.helpText)}</Text>
			<TextArea
				testId="servicedesk-widget-settings.ui.content.embed-code"
				id="embedCode"
				resize="auto"
				maxHeight="20vh"
				name="Embed code"
				value={embedCode}
				isReadOnly
				isMonospaced
				aria-label={formatMessage(messages.label)}
			/>

			<span>
				<Button
					appearance="primary"
					iconBefore={<CopyIcon label="copy code" size="medium" />}
					onClick={() => onCopy(embedCode)}
				>
					{formatMessage(messages.copyCodeButtonText)}
				</Button>
			</span>
		</Stack>
	);
};
